import { FormApi } from 'final-form'
import { get } from 'lodash'
import { useContext } from 'react'

import FormContext from './FormContext'

const useForm = (): FormApi => {
  const formContext = useContext(FormContext)

  return get(formContext, 'form') as FormApi
}

export default useForm
